module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step2_Image14.ba4ab3fb.jpg";